import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const Container = styled.div`
  box-sizing: border-box;
  display: flex;
  min-height: 24px;
  padding: 5px 10px;
  justify-content: center;
  align-items: center;
  border-radius: 0px 2px 2px 0px;
  border: 1px solid #626469;

  color: #626469;
  font-size: 16px;
  font-weight: 400;
  cursor: pointer;

  ${props => props.filled ? `background-color: ${props.fillColor}; border: 1px solid ${props.fillColor}; color: ${props.fillTextColor};` : ''}
  ${props => props.disabled ? 'opacity: 0.5;cursor: not-allowed;' : ''}
`;

const Label = styled.span``;

class SlotChip extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    label: PropTypes.string,
    filled: PropTypes.bool,
    disabled: PropTypes.bool,
    fillColor: PropTypes.string,
    fillTextColor: PropTypes.string,
    onClick: PropTypes.func
  };

  render = () => {
    return (
      <Container onClick={(event) => { if (this.props.onClick && !this.props.disabled) { this.props.onClick(event); } }} fillColor={this.props.fillColor} fillTextColor={this.props.fillTextColor} filled={this.props.filled} disabled={this.props.disabled}>
        <Label>{this.props.label}</Label>
      </Container>
    );
  };
}

export default SlotChip;
